// src/services/api/user.js
import { apiRequest } from "@/services/api/apiClient.js";

export async function getAnnotationById({ id }) {
    try {
        return await apiRequest({
            client: window.API_AUTH,
            method: "get",
            url: `/notepad/${id}`
        });
    } catch (error) {
        if (error?.response?.status === 404) {
            return null;
        }

        throw error;
    }
}

export async function saveAnnotation(data) {

    try {
        let url = `/notepad/${data.id}`;
        if (data.id === "*") return [];

        const response = await apiRequest({
            client: window.API_AUTH,
            method: "post",
            url,
            body: data,
        });
        return response;
    } catch (e) {
        return null
    }

}

